export const IMPORT_STATUS_CODE_PROCESSING = 'processing'
export const IMPORT_STATUS_CODE_LOADED = 'loaded'
export const IMPORT_STATUS_CODE_CANCELED = 'canceled'
